// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"f3925d72","159":"310b1daf","305":"f8e5ad14","538":"c184fec6"}[chunkId] + ".chunk.js";
};